import './App.css';
import React from "react";
import { withRouter } from "react-router-dom";
import { TITLE_HEALTH_CHECK } from './Constant';

class HealthCheck extends React.Component {

    componentDidMount(){
        document.title = {TITLE_HEALTH_CHECK}.TITLE_HEALTH_CHECK;
    }

    render() {
        return (
            <div className="page-container">
            </div>
        );
    }
}

export default withRouter(HealthCheck);